import { CATEGORY_CODE } from "constants/desktop-game/type";
import { PATH } from "constants/path";

export interface ItemMenu {
  name: string;
  image?: string;
  path: string;
  code?: string;
  isPopup?: boolean;
  isSubGame?: boolean;
}

export const listMenu: ItemMenu[] = [
  {
    name: "LIVE CASINO",
    path: `/${CATEGORY_CODE.LIVE_CASINO}`,
    code: CATEGORY_CODE.LIVE_CASINO,
  },
  {
    name: "SLOT",
    path: `/${CATEGORY_CODE.GAMES}`,
    code: CATEGORY_CODE.GAMES,
    isSubGame: true,
  },
  {
    name: "CHESS",
    path: `/${CATEGORY_CODE.CHESS_GAME}`,
    code: CATEGORY_CODE.CHESS_GAME,
    isSubGame: true,
  },
  {
    name: "SPORTS",
    path: `/${CATEGORY_CODE.SPORT}`,
    code: CATEGORY_CODE.SPORT,
  },
  {
    name: "FISH GAME",
    path: `/${CATEGORY_CODE.FISHING}`,
    code: CATEGORY_CODE.FISHING,
    isSubGame: true,
  },
  {
    name: "LOTTERY",
    path: `/${CATEGORY_CODE.LOTTERY}`,
    code: CATEGORY_CODE.LOTTERY,
  },
  {
    name: "RANKING",
    path: PATH.ranking,
    code: "#1",
    isPopup: false,
  },
  {
    name: "24h SERVICE",
    path: PATH.HelpCenter.index,
    code: "#2",
    isPopup: true,
  },
  {
    name: "PROMOTION",
    path: PATH.promotion,
    isPopup: true,
    code: "#1",
  },
];
